module.exports = __webpack_public_path__ + "static/brooklyn-dagger-f2d6746c1ccbf1a237aa78dd2f9a5a97.webp";